module.exports = __webpack_public_path__ + "img/file-spreadsheet.168e2244.svg";